/**
 * Virtual Account Details Component
 * Displays virtual account information for fund transfers
 * Extracted from original lines 601-656
 */

import { FC } from "react";
import { Text } from "@mantine/core";
import { COLORS } from "../../../constants/colors";
import { UI_TEXT } from "../StructureNote.constants";
import { InvestorAccountData } from "../StructureNote.types";

interface VirtualAccountDetailsProps {
  accountGAData: InvestorAccountData;
}

/**
 * Displays virtual account details for SGD transfers
 * Original logic from lines 601-656
 */
const VirtualAccountDetails: FC<VirtualAccountDetailsProps> = ({
  accountGAData,
}) => {
  return (
    <div>
      <Text
        style={{
          fontWeight: 800,
          marginTop: 10,
          marginBottom: 10,
        }}
      >
        {UI_TEXT.VIRTUAL_ACCOUNT_TITLE}
      </Text>

      {/* Account creation processing message (lines 611-623) */}
      {!accountGAData?.isActive ? (
        <Text
          style={{
            color: "black",
            fontStyle: "italic",
            fontSize: 16,
            textAlign: "left",
            padding: "10px 10px 10px 0px",
          }}
        >
          {UI_TEXT.ACCOUNT_PROCESSING}
        </Text>
      ) : (
        /* Account details display (lines 624-654) */
        <div style={{ display: "flex", gap: 30 }}>
          <div
            style={{
              backgroundColor: "#D9D9D980",
              borderRadius: 5,
              padding: "10px 30px",
            }}
          >
            <Text>Bank Name: {accountGAData?.investorSgdBankName ?? "-"}</Text>
            <Text>
              Account name: {accountGAData?.investorSgdBankAccountHolder ?? "-"}
            </Text>
            <Text>
              <span
                style={{
                  color: COLORS.agreementFont,
                  fontWeight: "bold",
                }}
              >
                SGD Account:{" "}
              </span>
              {accountGAData?.investorSgdBankAccountId ?? "-"}
            </Text>
            <Text>Swift code: {accountGAData?.investorSgdBicSwift ?? "-"}</Text>
          </div>
        </div>
      )}
    </div>
  );
};

export default VirtualAccountDetails;
